import React from 'react';
import PropTypes from 'prop-types';

import FilterTag from '@components/atoms/filter-tag/filterTag';
import EducationImage from '@components/atoms/education/image/educationImage';
import Headline from '@components/atoms/headline/headline';

import { ArrowRight } from '@components/icons/arrow/arrow';
import Link from 'next/link';
import EducationNumber from '@components/atoms/education/number/educationNumber';
import EducationTime from '@components/atoms/education/time/educationTime';
import MixedCopy from '@components/molecules/mixed-copy/mixedCopy';
import EducationContentType from '../content-type/educationContentType';
import StyledEducationCard from './educationCard.style';

function stripHtmlTags(text) {
  if (!text) return '';
  return text.replace(/(<([^>]+)>)/gi, '');
}

const EducationCard = ({
  title,
  copy,
  topics,
  contentType,
  duration,
  uri,
  image,
  numberedCard = false,
  number
}) => {
  const isNumbered = !!(numberedCard && number);

  return (
    <StyledEducationCard isNumbered={isNumbered}>
      {isNumbered && (
        <div className="card-number">
          <EducationNumber
            className="card-number__square"
            contentType={contentType}
            category={topics}
            number={number}
          />
          {duration && <EducationTime value={duration} />}
        </div>
      )}
      <div className="card">
        <div className="card__tag-line hidden--desktop">
          {topics && topics.length > 0 && topics.length < 7 && (
            <>
              {topics.map(item => (
                <FilterTag key={item.id} className="card__tag" inverted>
                  {item.title}
                </FilterTag>
              ))}
            </>
          )}
        </div>
        <div className="card__image">
          <EducationImage corner="20px" category={topics} contentType={contentType} image={image} />
        </div>
        <div className="card__content">
          <div className="card__text">
            <div className="card__tag-line hidden--mobile">
              {topics && topics.length > 0 && topics.length < 7 && (
                <>
                  {topics.map(item => (
                    <FilterTag key={item.id} className="card__tag" inverted>
                      {item.title}
                    </FilterTag>
                  ))}
                </>
              )}
              <EducationContentType contentType={contentType} />
            </div>
            <Link href={uri}>
              {title && (
                <Headline className="card__headline" tag="span">
                  {title.length > 110 ? `${title.substring(0, 110)}...` : title}
                </Headline>
              )}
              <span className="card__stretched-link" />
            </Link>
            <MixedCopy
              className="card__copy"
              fullWidth
              html={
                stripHtmlTags(copy).length > 140
                  ? `${stripHtmlTags(copy).substring(0, 140)}...`
                  : stripHtmlTags(copy)
              }
            />
          </div>
          <div className="card__arrow">
            <ArrowRight />
          </div>
        </div>
      </div>
    </StyledEducationCard>
  );
};

EducationCard.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  title: PropTypes.string.isRequired,
  copy: PropTypes.string,
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  contentType: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired,
  duration: PropTypes.number,
  uri: PropTypes.string.isRequired,
  numberedCard: PropTypes.bool,
  number: PropTypes.number
};

export default EducationCard;
